<template>
  <Head title="ボルダリングジム一覧" />

  <BreezeAuthenticatedLayout>
    <main class="container">
      <div class="main pickupG">
        <div class="c-header">
          <h2 class="c-header--h2 pl-0">ボルダリングジム一覧</h2>
        </div>
        <div class="pickupG_wrapper mt-24">
          <!-- start v-for -->
          <div class="pickupG_block" v-for="gym in gyms" :key="gym.id">
            <Link :href="`/gyms/${gym.slug}`">
              <figure class="pickupG_block_fig">
                <img :src="gym.image" class="pickupG_block_fig_img">
                <figcaption class="pickupG_block_title">
                  {{ gym.title }}
                </figcaption>
              </figure>
            </Link>
            <!-- admin or 特定gym owner only -->
            <div class="pickupG_block_operation" v-if="(auth.user && user.can.isAdmin) || (auth.user && user.can.isOwnerHigher && gym.users && gym.users.length > 0 && auth.user.id == gym.users[0].pivot.user_id)">
              <Link :href="`/gyms/${gym.id}/edit`" class="c-button half">編集</Link>
              <Link @click="destroy(gym.id)" class="c-button red half" v-if="auth.user && user.can.isAdmin">削除</Link >
            </div>
          </div>
          <!-- end v-for -->
        </div>

        <div class="admin-area" v-if="auth.user && user.can.isAdmin">
          <h3 class="admin-area_heading c-heading-h4">管理者エリア</h3>
          <Link :href="`/gyms/create`" class="c-button full">新しくジムを追加</Link>
        </div>

      </div>
      <Side />
    </main>
  </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import { Head, Link } from '@inertiajs/inertia-vue3';
import Side from '@/Shared/Side'

export default {
  components: {
    BreezeAuthenticatedLayout,
    Head,
    Link,
    Side,
  },
  props: {
    gyms: Array,
    user: Object,
    auth: Object
  },
  methods: {
    destroy(id) {
      if (confirm('本当に削除しますか？')) {
        this.$inertia.delete(route("gyms.destroy", id));
      }
    },
  },
}
</script>
